<nav class="inner-navbar-mobile">
    <!-- top -->
    <main-header-navbar-mobile-top [data]="{'top': top, 'logo': logo ,'account' : account, 'aboveTop': aboveTop, 'belowTop': belowTop}"
                                   [is-sidebar-open]="isOpen"
                                   (toggle)="onSidebarToggle()">
    </main-header-navbar-mobile-top>
    <!-- /top -->
    <!-- sidebar -->
    <main-header-navbar-mobile-side [data]="side"
                                    (click)="onSidebarClick($event)"
                                    (toggle)="onSidebarToggle()">
    </main-header-navbar-mobile-side>
    <!-- /sidebar -->
</nav>
